module.exports = __webpack_public_path__ + "static/media/combined~rUATIKbG.73ba48ed.svg";